// 333 Summer St., Boston, MA
export const INITIAL_SEARCH_LOCATION = {
  longitude: 42.3489128,
  latitude: -71.0507854
}

export const fetchUserLocation = async (
  onComplete: (location: { userLat: number; userLong: number }) => void
) => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (pos: GeolocationPosition) => {
        onComplete({
          userLat: pos.coords.latitude,
          userLong: pos.coords.longitude
        })
      },
      (_error: GeolocationPositionError) => {
        onComplete({
          userLat: INITIAL_SEARCH_LOCATION.latitude,
          userLong: INITIAL_SEARCH_LOCATION.longitude
        })
      },
      { maximumAge: Infinity, timeout: 10000 }
    )
  } else {
    onComplete({
      userLat: INITIAL_SEARCH_LOCATION.latitude,
      userLong: INITIAL_SEARCH_LOCATION.longitude
    })
  }
}
